
import { Component, Vue } from 'vue-property-decorator';
// 20211216 赵子龙要求 搜索条件改为和订单管理中的搜索项一样
import SearchCustom from '../orderServicer/components/OrderSearchCustom.vue';
import OrderList from './components/OrderList.vue';
import { OrderStage } from '../../types/orderComplaint';
import { ViewType } from '@/types/orderServicer';

@Component({
  name: 'orderComplaintUntreated',
  components: {
    SearchCustom,
    OrderList
  }
})
export default class extends Vue {
  private stage = OrderStage.COMPLETED;
  private vt = ViewType.ORDER_SERVICER_COMPLETED;
}
